import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ResearcherDashboardLayout = () => {
  const location=useLocation()
  const pathname=location.pathname
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/marketplace/dashboard/verification-status/`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: token ? `Bearer ${token}` : "",
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        if (!res.ok) {
          console.error("Failed to fetch profile:", res.status);
          navigate("/marketplace");
          return;
        }

        const data = await res.json();
        // console.log("Verification response:", data);

        // ✅ condition check
        if (data.is_verified === true && data.verification_type === "researcher") {
          setIsVerified(true);
        } else {
          // ❌ instantly redirect
          navigate("/marketplace", { replace: true });
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
        navigate("/marketplace");
      }
    };

    fetchProfile();
  }, [navigate, token]);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);
  // Optional: prevent flicker before verification
 if (!isVerified) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-indigo-600"></div>

        {/* Text */}
        <p className="text-sm font-medium text-gray-600">
          Verifying your researcher access...
        </p>
      </div>
    </div>
  );
}

  return (
       <div className="flex min-h-screen">
      {/* Sidebar */}
      <Sidebar
        isCollapsed={isMobile ? true : isSidebarCollapsed} // always collapsed on mobile
      />

      {/* Main content */}
      <div
        className={`flex-1 flex flex-col transition-margin duration-300
          ${
            isMobile
              ? "ml-20" // sidebar overlays or hidden on mobile
              : isSidebarCollapsed
              ? "ml-20"
              : "ml-72"
          }`}
      >
        <Header toggleSidebar={toggleSidebar} isCollapsed={isSidebarCollapsed} />
        <div className={`flex-1 ${pathname === "/marketplace/independent_researcher/dashboard/profile" ? "" : "p-2 md:p-6"}   overflow-auto space-y-6`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ResearcherDashboardLayout;
